import { useSelector } from "react-redux";
import ReusableDatagrid from "../components/ReusableDatagrid";

const columnsConfig = [
  {
    field: "ptaReview",
    headerName: "Preference(s)",
    width: 180,
    type: "select",
    label: "Select Action",
    options: [
      { value: "PTA Reviews", label: "PTA Reviews" },
      { value: "Other", label: "Other" },
    ],
  },
  {
    field: "receivedBy",
    headerName: "Received By",
    width: 280,
    placeholder: "Enter Received By",
  },
  {
    field: "preferenceDate",
    headerName: "Date",
    width: 220,
    type: "date",
    label: "Select Date",
    placeholder: "Select Date",
    valueGetter: (params) => {
      const value = params.row.preferenceDate;
      return value ? new Date(value) : null;
    },
  },
  {
    field: "notes",
    headerName: "Notes",
    width: 260,
    placeholder: "Enter Notes",
  },
];

const ClientPreferences = ({ mode }) => {
  const savedData = useSelector((state) => state.kotClient.clientPreferences);
  return <ReusableDatagrid title="Client Preferences" columnsConfig={columnsConfig} initialRows={savedData} section={"clientPreferences"} mode={mode} />;
};

export default ClientPreferences;
